module.exports = __webpack_public_path__ + "img/ee6a221.jpg";